import { HttpContextToken, HttpInterceptorFn } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

export const BYPASS_401_RESPONSE_HANDLER = new HttpContextToken(() => false);

// @Injectable()
// export class Handle401Interceptor implements HttpInterceptor {
// 	constructor(private router: Router) {}

//   intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
//     return next.handle(req).pipe(
//       catchError((err) => {
//         if (req.context.get(BYPASS_401_RESPONSE_HANDLER) === true) {
//           return next.handle(req);
//         }

//         if (err.status == 401) {
//           const evt = new Event('unauthorized');
//           window.dispatchEvent(evt);
//         }

//         return throwError(() => err);
//       })
//     );
//   }
// }

export const handle401InterceptorFn: HttpInterceptorFn = (req, next) => {
  return next(req).pipe(
    catchError((err) => {
      if (req.context.get(BYPASS_401_RESPONSE_HANDLER) === true) {
        return next(req);
      }

      if (err.status == 401) {
        const evt = new Event('unauthorized');
        window.dispatchEvent(evt);
      }

      return throwError(() => err);
    })
  );
};
